import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'
import { WorkspaceId } from 'honeygrid-types/validators-and-types/WorkspaceTypes'

import { connectionsQueryKey } from './useConnections'

import type { Connection } from 'honeygrid-types/validators-and-types/ConnectionTypes'

export const connectionQueryKey = (workspaceId: WorkspaceId, connectionId?: Connection['uuid']) =>
	[...connectionsQueryKey(workspaceId), connectionId] as const

interface ConnectionParams {
	workspaceId?: string
	connectionId?: Connection['uuid']
}

export const useConnection = ({ workspaceId = '', connectionId }: ConnectionParams) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<Connection>({
		queryKey: connectionQueryKey(workspaceId, connectionId),
		queryFn: (): Promise<Connection> =>
			authFetch(`workspaces/${workspaceId}/connections/${connectionId}`),
		enabled: !!workspaceId && !!connectionId,
	})
}
